import SeedLabelStatistics from "../SeedYear/SeedLabelStatistics";

export default class SubmissionStatistics {
  LabelStatistics: SeedLabelStatistics[] = [];
}
